import { HomeData } from '@practium/features/home';

export const companyHomeMockData: HomeData = {
	user: {
		name: 'AgroConsult',
		type: 'Empresa',
		plan: 'Enterprise',
	},

	carousel: [
		{
			id: '1',
			title: 'Conheça nosso treinamento completo para cadeia produtiva do café.',
			buttonText: 'Saber mais',
			buttonLink: '/saber-mais',
			imageUrl: '/images/carousel-slide-1.jpg',
		},
		{
			id: '2',
			title: 'Gerencie o catálogo de fertilizantes e defensivos da sua organização',
			buttonText: 'Gerenciar Produtos',
			buttonLink: '/produtos/catalogo',
			imageUrl: '/images/carousel-slide-2.jpg',
		},
		{
			id: '3',
			title: 'Auditoria de recomendações: garanta a qualidade técnica',
			buttonText: 'Auditar',
			buttonLink: '/enterprise/auditoria',
			imageUrl: '/images/carousel-slide-3.jpg',
		},
	],

	actionCards: [
		{
			id: 'flora-ai',
			title: 'Flora AI',
			subtitle: 'Tem alguma dúvida? Converse com a Flora, nossa IA especialista',
			buttonText: 'Falar agora',
			buttonLink: '/flora-ai',
			variant: 'flora',
		},
		{
			id: 'consultores',
			title: 'Equipe Técnica',
			subtitle: 'Gerencie permissões e vínculos dos seus consultores',
			buttonText: 'Gerenciar Equipe',
			buttonLink: '/usuarios',
			variant: 'applications',
		},
		{
			id: 'dashboard',
			title: 'Dashboard',
			subtitle: 'Não consegue visualizar? Veja agora a evolução da sua operação',
			buttonText: 'Ver agora',
			buttonLink: '/dashboard',
			variant: 'dashboard',
		},
	],

	calendar: {
		currentMonth: 'Janeiro',
		currentYear: 2026,
		events: [
			{
				id: '1',
				title: 'Reunião de Alinhamento - Q2',
				description: 'Revisão de metas com consultores sênior',
				date: '2026-01-11',
				type: 'reuniao',
				icon: '📊',
				color: 'var(--primary)',
			},
			{
				id: '2',
				title: 'Auditoria de Análises',
				description: 'Verificação amostral de laudos de solo',
				date: '2026-01-15',
				type: 'auditoria',
				icon: '✅',
				color: 'var(--primary)',
			},
			{
				id: '3',
				title: 'Atualização de Catálogo',
				description: 'Inserção de novos defensivos para a safra',
				date: '2026-01-20',
				type: 'administrativo',
				icon: '📦',
				color: 'var(--primary)',
			},
			{
				id: '4',
				title: 'Fechamento Mensal',
				description: 'Consolidação de relatórios de atendimento',
				date: '2026-01-29',
				type: 'financeiro',
				icon: '💰',
				color: 'var(--primary)',
			},
		],
		selectedPeriod: {
			start: '2026-01-11',
			end: '2026-01-20',
		},
	},

	history: [
		{
			id: '1',
			action: 'Novo consultor vinculado',
			department: 'RH',
			date: '10/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-10T08:00:00Z',
		},
		{
			id: '2',
			action: 'Novo fabricante cadastrado',
			department: 'Produtos',
			date: '09/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-09T16:00:00Z',
		},
		{
			id: '3',
			action: 'Exportação de dados de safra',
			department: 'Dados',
			date: '08/05/2026',
			status: 'Em breve',
			createdAt: '2026-05-08T14:00:00Z',
		},
		{
			id: '4',
			action: 'Atualização de política de privacidade',
			department: 'Legal',
			date: '05/05/2026',
			status: 'Concluído',
			createdAt: '2026-05-05T10:30:00Z',
		},
	],

	planInfo: {
		name: 'Enterprise',
		expirationDate: '01/12/26',
		upgradeMessage: 'Entre em contato para expandir o número de licenças de consultores.',
	},
};
